import React, {Component, PropType} from 'react'

class FeedbackComponent extends React.Component{    
    toggleClick(e){
        jQuery('#questionTab').toggle();
    }
    constructor(props){
        super(props);
        this.state={questionExplain:null}
    }
    render() {
        return (
            <div id="feedbackModal" className="modal fade" role="dialog">
                <div className="modal-dialog" style={{ width: '350px' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <button aria-hidden="true" className="close" data-dismiss="modal" type="button">×</button>
                            <h5 className="modal-title">Overview</h5>
                        </div>
                        <div className="modal-body box" id="feedback-body" style={{overflow:'auto',padding:"0px"}}>
                            <div className="tabbable box-content" style={{overflow:'auto',padding:'0px'}}>
                                <ul className="nav nav-tabs nav-tabs-simple">
                                    <li className="active" style={{padding:'0px'}}>
                                        <a data-toggle="tab" href="#lA">
                                            Query Description
                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content" style={{padding:"10px"}}>
                                    <div className="tab-pane active" id="lA">
                                        <p id="questionExplain"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default FeedbackComponent;